import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

function CustomCarousel({ slides }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [slideDone, setSlideDone] = useState(true);
  const [timeID, setTimeID] = useState(null);

  useEffect(() => {
    if (slideDone) {
      setSlideDone(false);
      setTimeID(
        setTimeout(() => {
          slideNext();
          setSlideDone(true);
        }, 3000)
      );
    }
  }, [slideDone]);

  const slideNext = () => {
    setActiveIndex((val) => {
      if (val >= slides.length - 1) {
        return 0;
      } else {
        return val + 1;
      }
    });
  };

  const slidePrev = () => {
    setActiveIndex((val) => {
      if (val <= 0) {
        return slides.length - 1;
      } else {
        return val - 1;
      }
    });
  };

  const AutoPlayStop = () => {
    if (timeID > 0) {
      clearTimeout(timeID);
      setSlideDone(false);
    }
  };

  const AutoPlayStart = () => {
    if (!slideDone) {
      setSlideDone(true);
    }
  };

  return (
    <div
      className="relative w-full max-w-6xl mx-auto group mb-4 mt-6 sm:mt-8 md:mt-10 px-4 sm:px-6"
      onMouseEnter={AutoPlayStop}
      onMouseLeave={AutoPlayStart}
    >
      <div className="relative overflow-hidden rounded-lg sm:rounded-xl shadow-lg h-32 sm:h-40 md:h-52 lg:h-72">
        {slides.map((slide, index) => {
          return (
            <div
              className={`absolute inset-0 w-full h-full transition-all duration-500 ease-in-out ${
                index === activeIndex
                  ? 'opacity-100 translate-x-0'
                  : index < activeIndex
                    ? 'opacity-0 -translate-x-full'
                    : 'opacity-0 translate-x-full'
              }`}
              key={index}
            >
              {slide}
            </div>
          );
        })}
      </div>
      <div className="absolute -bottom-2 sm:-bottom-3 left-1/2 transform -translate-x-1/2 z-30 flex space-x-1 sm:space-x-2">
        {slides.map((_, index) => {
          return (
            <button
              key={index}
              className={`rounded-md transition-all duration-300 ${
                activeIndex === index
                  ? 'bg-[#707070] scale-110'
                  : 'bg-[#E5E5E5] hover:bg-white/80'
              } w-3 h-1 xs:w-4 xs:h-1.5 sm:w-5 sm:h-1`}
              onClick={(e) => {
                e.preventDefault();
                setActiveIndex(index);
              }}
            />
          );
        })}
      </div>
      <button
        className="absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 z-30 
                   bg-white/90 hover:bg-[#707070] hover:text-white text-black 
                   rounded-lg sm:rounded-r-lg shadow-md transition-all duration-300 
                   flex items-center justify-center backdrop-blur-sm
                   w-6 h-8 xs:w-7 xs:h-10 sm:w-8 sm:h-12
                   opacity-80 group-hover:opacity-100 active:opacity-100
                   sm:opacity-0 sm:group-hover:opacity-100
                   text-sm xs:text-base sm:text-lg"
        onClick={(e) => {
          e.preventDefault();
          slidePrev();
        }}
      >
        <FaChevronLeft />
      </button>
      <button
        className="absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 z-30 
                   bg-white/90 hover:bg-[#707070] hover:text-white text-black 
                   rounded-lg sm:rounded-l-lg shadow-md transition-all duration-300 
                   flex items-center justify-center backdrop-blur-sm
                   w-6 h-8 xs:w-7 xs:h-10 sm:w-8 sm:h-12
                   opacity-80 group-hover:opacity-100 active:opacity-100
                   sm:opacity-0 sm:group-hover:opacity-100
                   text-sm xs:text-base sm:text-lg"
        onClick={(e) => {
          e.preventDefault();
          slideNext();
        }}
      >
        <FaChevronRight />
      </button>
      <div className="sm:hidden absolute inset-y-0 left-0 w-1/4 z-20" 
           onClick={slidePrev} />
      <div className="sm:hidden absolute inset-y-0 right-0 w-1/4 z-20" 
           onClick={slideNext} />
    </div>
  );
}

export default CustomCarousel;